import { ChangeDetectionStrategy, Component, effect, input, output, signal } from '@angular/core';

import { FlooriIconComponent } from '../floori-icon';

@Component({
    selector: 'floori-expansion-panel',
    standalone: true,
    imports: [FlooriIconComponent],
    templateUrl: './floori-expansion-panel.component.html',
    styleUrl: './floori-expansion-panel.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FlooriExpansionPanelComponent {
    private readonly _isExpanded = signal(false);

    readonly title = input<string>('');
    readonly subtitle = input<string>('');
    readonly expanded = input(false);

    readonly expandedChange = output<boolean>();

    constructor() {
        effect(() => this._isExpanded.set(this.expanded()));
    }

    toggle(): void {
        this._isExpanded.update(isExpanded => !isExpanded);
        this.expandedChange.emit(this._isExpanded());
    }

    isExpanded(): boolean {
        return this._isExpanded();
    }
}
